import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id", "disabled", "placeholder", "required", "maxlength", "minlength"];
import { ref, watch } from "vue";
import log from "../../services/Logger";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlJson',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur'
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const fieldOptions = props.field.options || {};
        const model = ref(createModel());
        const invalid = ref(false);
        function createModel() {
            if (props.data === undefined || props.data === null) {
                return undefined;
            }
            else {
                return JSON.stringify(props.data, null, 2);
            }
        }
        // changes from the outside
        watch(() => props.data, () => model.value = createModel());
        // changes from the inside
        function onChange() {
            const value = model.value;
            let json;
            try {
                json = value && JSON.parse(value);
                invalid.value = false;
            }
            catch (e) {
                invalid.value = true;
                return;
            }
            log('FieldControlJson@change', props.field.name, json);
            emit('change', json);
        }
        function onFocus() {
            emit('focus');
        }
        function onBlur() {
            emit('blur');
        }
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("textarea", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                onInput: onChange,
                onFocus: onFocus,
                onBlur: onBlur,
                id: __props.fieldId,
                disabled: _unref(fieldOptions).disabled ?? undefined,
                placeholder: _unref(fieldOptions).placeholder ?? undefined,
                required: _unref(fieldOptions).required ?? undefined,
                maxlength: _unref(fieldOptions).maxLength ?? undefined,
                minlength: _unref(fieldOptions).minLength ?? undefined,
                class: _normalizeClass(["form__control", { 'form__control--json': true, 'form__control--invalid': invalid.value }])
            }, null, 42, _hoisted_1)), [
                [
                    _vModelText,
                    model.value,
                    void 0,
                    { trim: true }
                ]
            ]);
        };
    }
});
